<template>
    <Skeleton v-if="isLoading" />
    <template v-else-if="results.length > 0">
        <div class="dynamicMarketResult_header">
            <div class="dynamicMarketResult_marketName" />
            <div class="dynamicMarketResult_score">
                {{ finalScoreText }}
            </div>
        </div>
        <div
            v-for="result in results"
            v-bind:key="result.marketId"
            class="dynamicMarketResult_row"
        >
            <div class="dynamicMarketResult_marketName">
                {{ result.marketName }}
            </div>
            <div class="dynamicMarketResult_score">
                <StatusTag
                    v-if="result.isRefunded"
                    v-bind:text="refundedText"
                    size="sm"
                />
                <template v-else-if="result.selectionResults.length === 0">
                    --
                </template>
                <template v-else>
                    <div
                        v-for="(selectionResult, selectionIndex) in result.selectionResults"
                        v-bind:key="selectionResult.selectionId"
                    >
                        {{ selectionResult.name
                        }}<span v-if="selectionIndex < result.selectionResults.length - 1">,</span>
                    </div>
                </template>
            </div>
        </div>
    </template>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue';
    import { computed, ref } from 'vue';
    import Skeleton from '@/components/common/skeleton/Skeleton.vue';
    import StatusTag from '@/components/common/statusTag/StatusTag.vue';
    import { Api } from '@/core/lib/api';
    import { i18n } from '@/core/lib/i18n';
    import type { IDynamicMarketResult } from '@/interface/IResult';
    import type { SportType } from '@/interface/enum';

    const props = defineProps({
        sportType: {
            type: Number as PropType<SportType>,
            required: true,
        },
        matchId: {
            type: Number,
            required: true,
        },
    });

    const isLoading = ref(true);
    const results = ref<IDynamicMarketResult[]>([]);

    const finalScoreText = computed(() => i18n.t('results_header_final_score'));
    const refundedText = computed(() => i18n.t('bet_status_5'));

    async function getResults() {
        try {
            isLoading.value = true;
            results.value = await Api.getDynamicMarketResults(
                props.sportType,
                props.matchId,
            );
        } catch (e) {
            console.error(e);
        } finally {
            isLoading.value = false;
        }
    }

    getResults();
</script>

<style lang="scss" scoped>
@import "@/components/results/DynamicMarketResult";
</style>
